import axios from "axios";
import { useEffect, useRef } from "react";
import { useAppContext } from "../common/context/AppContext";

export const apiClient = axios.create({
    timeout: 120000,
    timeoutErrorMessage: "timeout",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
    },
});

export const playgroundClient = axios.create({
    timeout: 120000,
    timeoutErrorMessage: "timeout",
    baseURL: `${process.env.REACT_APP_PLAYGROUND_BACKEND_URL}`,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
    },
});

const platformClient = axios.create({
    timeout: 120000,
    timeoutErrorMessage: "timeout",
    baseURL: `${process.env.REACT_APP_PLAYGROUND_BACKEND_URL}/api/v2`,
    withCredentials: true,
    credentials: "include",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8",
    },
});

export function UsePlatformApi() {
    const abortControllerRef = useRef(null);
    const { authTokens, setApiReady } = useAppContext();

    // AuthTokens
    useEffect(() => {
        if (!authTokens) return;

        const requestIntercept = platformClient.interceptors.request.use(
            (config) => {
                config.headers["Authorization"] = `Bearer ${authTokens.access}`;
                config.headers["X-CSRFToken"] = authTokens.csrf;
                return config;
            },
            (error) => Promise.reject(error)
        );
        setApiReady(true);

        return () => {
            platformClient.interceptors.request.eject(requestIntercept);
            setApiReady(false);
        };
    }, [authTokens]);

    // Abort Controller
    useEffect(() => {
        abortControllerRef.current = new AbortController();
        const requestIntercept = platformClient.interceptors.request.use(
            (config) => {
                config.signal = abortControllerRef.current.signal;
                return config;
            },
            (error) => Promise.reject(error)
        );
        return () => {
            setApiReady(false);
            abortControllerRef.current?.abort();
            platformClient.interceptors.request.eject(requestIntercept);
        };
    }, []);

    return platformClient;
}
